import AuthMobileLayout from "@/components/auth/authMobileLayout";
import AuthWebLayout from "@/components/auth/authWebLayout";
import TermsAndPrivacy from "@/components/auth/termsAndPrivacy";
import UpdateDetails from "@/components/auth/updateDetails";
import Page from "@/components/page";
import useIsSmallScreen from "@/hooks/useIsSmallScreen";
import { withPageInitialLoad } from "@/libs/pageDataBridge";
import React from "react";
import { useTranslation } from "react-i18next";

const UpdateDetailsPage = () => {
  const { isSmallScreen } = useIsSmallScreen();
  const { t } = useTranslation(["seo"]);

  const contentRender = (
    <div>
      <UpdateDetails isMobile={isSmallScreen} />
    </div>
  );

  return (
    <Page
      title={t("seo:joinTitle")}
      id="signup"
      className="register_user_page_wrapper"
    >
      {isSmallScreen ? (
        <AuthMobileLayout signUp className="signUpLayout">
          {contentRender}
        </AuthMobileLayout>
      ) : (
        <AuthWebLayout signUp className="signUpLayout">
          {contentRender}
        </AuthWebLayout>
      )}
    </Page>
  );
};

export default withPageInitialLoad({
  pageName: "UpdateDetails",
  page: UpdateDetailsPage,
  ssr: false,
  loader: true
});
